import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=8a4c3322&scoped=true&"
import script from "./Counseling.vue?vue&type=script&lang=ts&"
export * from "./Counseling.vue?vue&type=script&lang=ts&"
import style0 from "./Counseling.vue?vue&type=style&index=0&id=8a4c3322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4c3322",
  null
  
)

export default component.exports